<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button class="btn-primary" size="small" icon="el-icon-plus" v-if="permission.addrandprecord" @click="showAddRecordDialog()">
                    {{ permission.addrandprecord }}
                </el-button>
                <el-button
                    class="btn-primary"
                    size="small"
                    v-if="permission.baseScoreSet && (baseScoreConfig == null ? false : baseScoreConfig.Result)"
                    @click="showConfigDialog()"
                >
                    {{ permission.baseScoreSet }}
                </el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">部门</div>
                <el-cascader
                    class="search-item"
                    v-model="searchData.OrgId"
                    :options="orgSearchData"
                    :props="cascaderProps"
                    size="small"
                    clearable
                    @change="getSIdData"
                ></el-cascader>
                <div class="search-name">业务员</div>
                <el-select v-model="searchData.SId" size="small" class="search-item" filterable placeholder="请选择">
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">记录时间</div>
                <el-date-picker
                    class="search-name"
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    size="small"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleChange"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
                <div class="search-name">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" :default-sort="{ prop: 'TotalScore', order: 'descending' }">
                <el-table-column show-overflow-tooltip width="80px" type="index" sortable label="排名"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="OrgName" label="部门"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="BaseScore" label="基础分"></el-table-column>
                <el-table-column show-overflow-tooltip sortable min-width="100" prop="RewardTotalScore" label="奖赏总分"></el-table-column>
                <el-table-column show-overflow-tooltip sortable min-width="100" prop="RewardTimes" label="奖赏次数"></el-table-column>
                <el-table-column show-overflow-tooltip sortable min-width="100" prop="PunishTotalScore" label="惩罚分数"></el-table-column>
                <el-table-column show-overflow-tooltip sortable min-width="100" prop="PunishTimes" label="惩罚次数"></el-table-column>
                <el-table-column show-overflow-tooltip :render-header="renderHeader" sortable min-width="100" prop="TotalScore" label="总分"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="赏罚明细" size="mini" type="text" @click="showStaffDetailDialog(scope.row)">赏罚明细</el-button>
                        </div>
                    </template></el-table-column
                >
            </el-table>
        </div>
        <el-dialog
            :append-to-body="true"
            :close-on-click-modal="false"
            :before-close="clearDialog"
            title="基础分设置"
            :visible.sync="dialogVisible"
            custom-class="base-dialog"
            width="400px"
            v-loading.fullscreen="false"
        >
            <div class="dialog-content">
                <template>
                    <el-form :model="baseScoreConfig" ref="accountFormData" label-width="110px">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div class="grid-content">
                                    <el-form-item label="基础分" prop="RValue">
                                        <el-input-number v-model="baseScoreConfig.RValue" controls-position="right"></el-input-number>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearDialog">取 消</el-button>
                <el-button class="btn-primary" @click="submitConfig">确 定</el-button>
            </span>
        </el-dialog>
        <!--    新增/编辑奖罚记录    -->
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="editVisible" width="800px">
            <div class="dialog-content" v-if="editVisible">
                <rewardAndPRecordEdit :RecordData="recordData" @closeDialog="closeEdit"></rewardAndPRecordEdit>
            </div>
        </el-dialog>
        <!--    奖罚记录清单，针对个人    -->
        <el-dialog :close-on-click-modal="false" title="奖罚记录" :visible.sync="showRAndPDetailDialog" :append-to-body="true" width="1400px" @close="getTableData">
            <div v-if="showRAndPDetailDialog">
                <rewardAndPRecordDetail :StaffId="staffId" :OrgId="orgId"></rewardAndPRecordDetail>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import rewardAndPRecordEdit from '@/components/business/msgSetting/rewardAndPRecordEdit';
import rewardAndPRecordDetail from '@/components/business/msgSetting/rewardAndPRecordDetail';
export default {
    mixins: [mixin],
    name: '',
    components: { breadcrumb, rewardAndPRecordEdit, rewardAndPRecordDetail },
    data() {
        return {
            dateTimes: '',
            recordData: {},
            staffId: '',
            orgId: '',
            baseScoreConfig: {},
            dialogVisible: false,
            editVisible: false,
            showRAndPDetailDialog: false,
            orgSearchData: [],
            baseScoreFormData: {},
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                OrgId: '',
                SId: '',
                StartDate: '',
                EndDate: ''
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            tableData: [],
            title: '新增奖罚记录',
            permission: {}, //该页面的权限
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        this.permission = this.$util.getPermission('staffManagement');
        this.getBaseScoreConfig();
        this.getOrgTree();
        this.getPassYearFormatDate();
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
    },
    methods: {
        /* 获取过去时间，并传值给现在时间 */
        getPassYearFormatDate() {
            let nowDate = new Date();
            let date = new Date(nowDate);
            date.setDate(date.getDate() - 30);
            let seperator1 = '-';
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            let formatDate = year + seperator1 + month + seperator1 + strDate;
            this.getNowFormatDate(formatDate);
        },
        /* 获取现在时间，并接受过去时间的值 */
        getNowFormatDate(formatDate) {
            let date = new Date();
            let seperator1 = '-';
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = '0' + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = '0' + strDate;
            }
            let nowData = year + seperator1 + month + seperator1 + strDate;
            this.dateTimes = [formatDate, nowData]; // 默认赋值一年时间
            this.searchData.StartDate = formatDate;
            this.searchData.EndDate = nowData;
        },
        renderHeader(h, { column }) {
            const scoreContent = [
                h(
                    'div',
                    {
                        slot: 'content',
                        style: 'margin-bottom:5px'
                    },
                    '总分的计算公式：'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '总分 = 基础分 + 奖赏总分 - 惩罚总分'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        scoreContent,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        // 重置表单
        resetSearch() {
            this.dateTimes = [];
            this.searchData = {
                OrgId: '',
                SId: '',
                StartDate: '',
                EndDate: '',
                EntpId: this.$util.getLocalStorage('userMsg').EntpId
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetStaffRAndPRecordStat',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                })
                .catch(() => {});
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getOrgTree() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetOrgTree'
                })
                .then(res => {
                    if (res.data) {
                        this.orgSearchData = this.getTreeData(res.data);
                    }
                });
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        //获取基础分设置
        getBaseScoreConfig() {
            this.$util.getSysConfig('ygsffz').then(res => {
                this.baseScoreConfig = res;
            });
        },
        // 提交基础分设置值
        submitConfig() {
            this.$util.setSysConfigValue(this.baseScoreConfig.ConfigId, this.baseScoreConfig.RValue);
            this.clearDialog();
        },
        showAddRecordDialog() {
            this.editVisible = true;
        },
        showConfigDialog() {
            this.dialogVisible = true;
        },
        closeEdit() {
            this.editVisible = false;
        },
        clearDialog() {
            this.getTableData();
            this.dialogVisible = false;
        },
        showStaffDetailDialog(item) {
            this.staffId = item.SId;
            this.orgId = item.OrgId;
            this.showRAndPDetailDialog = true;
        }
    }
};
</script>